import { useEffect } from 'react';
import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import { AlertModal } from '../../components/AlertModal';
import { publish } from '../../../features/EventsBus';
import { MeetDomainEvents } from '../../../features/Meet/domain';

export default function UnavailableMeetPage() {
	const { t } = useTranslationsContext();

	useEffect(() => {
		publish(MeetDomainEvents.unavailableMeet);
	}, []);

	return (
		<AlertModal
			type="error"
			title={t('errors.title_finished_meet')}
			message={t('errors.finished_meet')}
		/>
	);
}
